import type { EatalyBreadcrumbItem } from './index';

export type PreviousBreadcrumbTarget = {
    item: EatalyBreadcrumbItem;
    index: number;
};

/** Nearest ancestor that has a destination, walking back from the current page. */
export function findPreviousBreadcrumbTarget(items: readonly EatalyBreadcrumbItem[]): PreviousBreadcrumbTarget | null {
    for (let index = items.length - 2; index >= 0; index -= 1) {
        const item = items[index];
        if (item?.href) {
            return { item, index };
        }
    }

    return null;
}

/** True when the single-line trail is wider than the breadcrumb container. */
export function isBreadcrumbTrailOverflowing(trailWidth: number, containerWidth: number): boolean {
    return containerWidth > 0 && trailWidth > containerWidth;
}
